import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "ai",
    iconColor: "white",
    text: "AI cognitive core to drive \ndecisioning orchestration",
    listItemCustomStyle: { width: "304px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithLight2",
    iconColor: "white",
    text: "Gen-AI/AI powered \ndomain agents for \ncontent creation, \nMMD, MMX, MTA & \npersonalization",
    listItemCustomStyle: { width: "271px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithGraph",
    iconColor: "white",
    text: "Marketing control \ntower and decision \nboard",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_AI_TWIN_4 = {
  title: "40% REDUCTION IN NON-WORKING \nCAPITAL SPEND ON MARKETING",
  titleNumber: "4.",
  text: "Enabling AI-first core across marketing value chain to drive efficiencies through real\ntime analysis of and activation of intelligence across marketing planning, content\ncreation, content curation, consumer cultivation, campaign operations,\npersonalization and spend optimization.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "CHALLENGES SOLVED",
    onClick: () => setCurrentPage("AITWIN_313"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("AITWIN_304"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_06.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "AI_TWIN/InfosysTopazLogo.png",
};
